import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette }) => ({
  invoice_details: {
    backgroundColor: palette.primary.light,
    padding: 12,
    wordBreak: "break-word",
  },
}));
